import { apiClient } from './client';

export type SignatureMethod = 'DRAWN' | 'UPLOADED';

export interface StudentSignatureMeta {
  id: number;
  studentId: number;
  mimeType: string;
  sizeBytes: number;
  method: SignatureMethod;
  createdById: number;
  createdAt: string;
  updatedAt: string;
}

const saveSignature = async (url: string, method: SignatureMethod, file: Blob): Promise<StudentSignatureMeta> => {
  const formData = new FormData();
  formData.append('method', method);
  formData.append('file', file, method === 'DRAWN' ? 'signature.png' : (file as File).name ?? 'signature');
  const { data } = await apiClient.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  return data.data;
};

const getSignature = async (url: string): Promise<StudentSignatureMeta | null> => {
  const { data } = await apiClient.get(url);
  return data.data;
};

const getSignatureImageBlob = async (url: string): Promise<{ blob: Blob; mimeType: string }> => {
  const response = await apiClient.get(url, { responseType: 'blob' });
  return { blob: response.data, mimeType: String(response.headers['content-type'] ?? 'image/png') };
};

/** Staff-facing surface — gated by documents:view/upload, same permission
 * `generateDocument` already requires (see students.route.ts). */
export const getStudentSignature = (studentId: number) => getSignature(`/students/${studentId}/signature`);
export const getStudentSignatureImage = (studentId: number) =>
  getSignatureImageBlob(`/students/${studentId}/signature/image`);
export const saveStudentSignature = (studentId: number, method: SignatureMethod, file: Blob) =>
  saveSignature(`/students/${studentId}/signature`, method, file);

/** Student Portal self-service surface — always the caller's own linked
 * student, never a student id in the URL (see studentPortal.route.ts). */
export const getOwnSignature = () => getSignature('/portal/signature');
export const getOwnSignatureImage = () => getSignatureImageBlob('/portal/signature/image');
export const saveOwnSignature = (method: SignatureMethod, file: Blob) => saveSignature('/portal/signature', method, file);
